import { render, staticRenderFns } from "./DiseasesCategorizedConfig.vue?vue&type=template&id=f709b594&scoped=true"
import script from "./DiseasesCategorizedConfig.vue?vue&type=script&lang=js"
export * from "./DiseasesCategorizedConfig.vue?vue&type=script&lang=js"
import style0 from "./DiseasesCategorizedConfig.vue?vue&type=style&index=0&id=f709b594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f709b594",
  null
  
)

export default component.exports